import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpurtaxi() {



const cardData = {
  keyword: " Pune to Pandharpur Taxi  ",

"headingDescription": "Pune to Pandharpur Taxi service provides a comfortable, safe, and hassle-free journey for pilgrims and travelers heading to one of Maharashtra’s most revered spiritual destinations. SRS Cab Service ensures timely pickups, experienced drivers, and well-maintained vehicles for a smooth ride from Pune to Pandharpur. Ideal for family trips, devotional tours, or group travel, our taxi service offers flexible booking, transparent fares, and 24/7 customer support so you can focus on your spiritual journey without any travel worries.",
"topPlaces": [
  {
    "title": "Vithoba Temple",
    "description": "Vithoba Temple is the main attraction in Pandharpur, dedicated to Lord Vitthal (Vithoba). Travelers booking Pune to Pandharpur Taxi visit this sacred temple to offer prayers and experience the spiritual aura of the town."
  },
  {
    "title": "Chandrabhaga River",
    "description": "Chandrabaga River flows beside the Vithoba Temple and holds religious significance. Visitors using Pune to Pandharpur Taxi often take a holy dip here during their pilgrimage."
  },
  {
    "title": "Sant Tukaram Maharaj Samadhi",
    "description": "This site commemorates the life and teachings of the revered saint Tukaram. Travelers using Pune to Pandharpur Taxi often visit to pay respects and learn about his devotion and philosophy."
  },
  {
    "title": "Sant Dnyaneshwar Maharaj Samadhi",
    "description": "The Samadhi of Sant Dnyaneshwar is a spiritual site in Pandharpur. Pilgrims booking Pune to Pandharpur Taxi include this location for blessings and meditation."
  },
  {
    "title": "Rukmini Temple",
    "description": "Rukmini Temple is dedicated to Goddess Rukmini, consort of Lord Krishna. Visitors using Pune to Pandharpur Taxi explore this temple to experience its spiritual and historical significance."
  },
  {
    "title": "Padmalaya",
    "description": "Padmalaya is a serene garden and relaxation spot near the Vithoba Temple. Travelers using Pune to Pandharpur Taxi often visit here to enjoy peace and calm surroundings."
  },
  {
    "title": "Bhakti Mandir",
    "description": "Bhakti Mandir is a cultural and devotional center showcasing spiritual activities. Visitors booking Pune to Pandharpur Taxi often attend rituals and devotional gatherings here."
  },
  {
    "title": "Sant Namdev Maharaj Samadhi",
    "description": "Sant Namdev Maharaj Samadhi is another significant pilgrimage site in Pandharpur. Travelers using Pune to Pandharpur Taxi include this destination in their spiritual itinerary."
  },
  {
    "title": "Pandharpur Market",
    "description": "The Pandharpur Market offers local handicrafts, religious souvenirs, and traditional snacks. Visitors using Pune to Pandharpur Taxi explore the market for shopping and cultural experience."
  },
  {
    "title": "Vitthal-Rukmini Fair",
    "description": "Vitthal-Rukmini Fair is a traditional event attracting thousands of devotees. Travelers using Pune to Pandharpur Taxi may plan their visit to coincide with this vibrant festival."
  }
],



services: [
{
name: "Pandharpur to Pune Cab",
description: "Pandharpur to Pune cab offers reliable return travel for devotees and travelers. Customers can book cabs for smooth intercity journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pandharpur to Pune with cab services."
},
{
name: "Pune to Pandharpur Cab",
description: "Pune to Pandharpur cab provides convenient travel for Vitthal darshan trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Pune to Pandharpur cab services."
},
{
name: "Pune to Pandharpur Cab Service",
description: "Pune to Pandharpur cab service offers reliable transportation for pilgrimage travel. Customers can book cabs for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Choose cab services for Pune to Pandharpur travel."
},
{
name: "Pune to Akkalkot Cab",
description: "Pune to Akkalkot cab provides convenient travel for spiritual journeys. Customers can visit Swami Samarth temple easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Akkalkot with cab services."
},
{
name: "Pune to Akkalkot Taxi",
description: "Pune to Akkalkot taxi offers reliable transportation for pilgrimage trips. Customers can book taxis for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services from Pune."
},
{
name: "Pune to Akkalkot Car Rental Price",
description: "Pune to Akkalkot car rental price provides clear pricing for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose car rental services with transparent pricing."
},
{
name: "Pune to Akkalkot Darshan Package",
description: "Pune to Akkalkot darshan package offers complete travel for temple visits. Customers can enjoy organized pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book darshan packages from Pune easily."
},
{
name: "Pune to Tuljapur Cab",
description: "Pune to Tuljapur cab provides reliable travel for temple visits. Customers can visit Tulja Bhavani temple comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Tuljapur with cab services."
},
{
name: "Pune to Tuljapur Cab Fare",
description: "Pune to Tuljapur cab fare provides detailed pricing for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Tuljapur Car Rental",
description: "Pune to Tuljapur car rental offers flexible vehicle options for pilgrimage trips. Customers can rent cars for comfortable travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Tuljapur easily."
},
{
name: "Pune to Solapur Cab",
description: "Pune to Solapur cab offers convenient travel for intercity journeys. Customers can book cabs for business and pilgrimage trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Solapur."
},
{
name: "Pune to Solapur One Way Cab",
description: "Pune to Solapur one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Solapur."
},
{
name: "Pune to Pandharpur Tempo Traveller on Rent",
description: "Pune to Pandharpur tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for family and group trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel together with tempo traveller services."
},
{
name: "Innova Taxi from Pune to Solapur",
description: "Innova taxi from Pune to Solapur offers premium SUV travel for comfort. Customers can enjoy spacious seating for long journeys. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova taxi services."
},
{
name: "Pune to Solapur Ertiga Taxi",
description: "Pune to Solapur Ertiga taxi offers comfortable 7-seater travel for families. Customers can enjoy smooth long-distance journeys. Professional drivers ensure safe travel. Ideal for group trips. Transparent pricing ensures affordability. Travel easily with Ertiga taxi services."
},
{
name: "Pune to Tuljapur Innova Crysta Taxi",
description: "Pune to Tuljapur Innova Crysta taxi offers premium travel with extra comfort. Customers can enjoy spacious seating and smooth journeys. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta services."
},
{
name: "Pune to Tuljapur to Akkalkot to Gangapur Cab Package",
description: "Pune to Tuljapur Akkalkot Gangapur cab package offers complete pilgrimage travel. Customers can visit multiple temples in one trip. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book multi-destination cab packages easily."
},
{
name: "Pune to Tuljapur Ertiga Cab",
description: "Pune to Tuljapur Ertiga cab offers comfortable 7-seater travel for devotees. Customers can enjoy smooth journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Pandharpur Taxi Fare",
description: "Pune to Pandharpur taxi fare provides pricing details for pilgrimage travel. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Pandharpur Cab Charges",
description: "Pune to Pandharpur cab charges offer clear pricing for travelers. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Pandharpur Taxi Booking",
description: "Pune to Pandharpur taxi booking provides easy reservation options for travelers. Customers can book taxis online instantly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Pandharpur Car Rental",
description: "Pune to Pandharpur car rental offers flexible vehicle options for pilgrimage trips. Customers can rent cars for comfortable travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Pandharpur easily."
},
{
name: "Pune to Pandharpur Taxi Service",
description: "Pune to Pandharpur taxi service offers dependable transportation for temple visits. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Pandharpur Cab Booking",
description: "Pune to Pandharpur cab booking offers quick and easy reservation options. Customers can book cabs online or via apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily from Pune."
}
],

tableData: [
["Pandharpur to Pune Cab","Pune to Pandharpur Cab"],
["Pune to Pandharpur Cab Service","Pune to Akkalkot Cab"],
["Pune to Akkalkot Taxi","Pune to Akkalkot Car Rental Price"],
["Pune to Akkalkot Darshan Package","Pune to Tuljapur Cab"],
["Pune to Tuljapur Cab Fare","Pune to Tuljapur Car Rental"],
["Pune to Solapur Cab","Pune to Solapur One Way Cab"],
["Pune to Pandharpur Tempo Traveller on Rent","Innova Taxi from Pune to Solapur"],
["Pune to Solapur Ertiga Taxi","Pune to Tuljapur Innova Crysta Taxi"],
["Pune to Tuljapur to Akkalkot to Gangapur Cab Package","Pune to Tuljapur Ertiga Cab"],
["Pune to Pandharpur Taxi Fare","Pune to Pandharpur Cab Charges"],
["Pune to Pandharpur Taxi Booking","Pune to Pandharpur Car Rental"],
["Pune to Pandharpur Taxi Service","Pune to Pandharpur Cab Booking"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Pandharpur routes, ensuring safe driving and smooth travel for a comfortable darshan journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Pandharpur Taxi Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Pandharpur taxi services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Service for Darshan Travel",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Pandharpur taxi bookings, making it convenient for early morning darshan, same-day return trips, and flexible travel plans."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable and peaceful journey to Pandharpur."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way taxi service, round-trip bookings, and customized Pandharpur darshan packages from Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for family and group pilgrimage trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Pandharpur Taxi Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Pandharpur taxi bookings due to punctual service, safe travel, and reliable vehicles for temple visits."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Pandharpur taxi service?", answer: "Yes, SRS Cab Service offers reliable taxi services from Pune to Pandharpur for darshan travel." },
  { question: "How far is Pandharpur from Pune?", answer: "The distance between Pune and Pandharpur is approximately 210 km and the journey takes around 4 to 5 hours." },
  { question: "Is Pune to Pandharpur taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pandharpur trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Pune to Pandharpur?", answer: "Yes, we provide both one-way and round-trip taxi services." },
  { question: "Do you provide same-day return for Pandharpur?", answer: "Yes, we offer same-day return packages for Pandharpur darshan from Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the taxi online?", answer: "Yes, you can easily book Pune to Pandharpur taxi service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Jadhav",
    feedback:
      "Booked SRS Cab Service for Pandharpur darshan. Smooth journey and driver was very cooperative.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Kulkarni",
    feedback:
      "Excellent Pune to Pandharpur taxi service. Comfortable ride and perfect for family pilgrimage.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Taxi | SRS Cab",
  "description": "SRS Cab provides Pune to Pandharpur taxi and cab services including one-way and round trips, car rentals, and temple darshan packages. Travel comfortably to Pandharpur, Akkalkot, Tuljapur, and Solapur with affordable fares, Innova and Tempo Traveller options, and 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pune to Pandharpur Taxi | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Pandharpur taxi with SRS Cab. One-way, round trips, car rentals, and temple darshan packages to Pandharpur, Akkalkot, Tuljapur, and Solapur. Comfortable rides with Innova and Tempo Traveller options and 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopandharpurtaxi;